export var TradeSide;(function(TradeSide){TradeSide[TradeSide["BUY"]=1]="BUY";TradeSide[TradeSide["SELL"]=2]="SELL";})(TradeSide||(TradeSide={}));